import { render, staticRenderFns } from "./ReservaCartaoList.vue?vue&type=template&id=e8628206&scoped=true&"
import script from "./ReservaCartaoList.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoList.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoList.vue?vue&type=style&index=0&id=e8628206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8628206",
  null
  
)

export default component.exports